import React, { useContext, useEffect } from 'react';

import { TrackEventContext } from 'common/containers/EventContainer';
import AsanaLandingHelmet from 'common/helmets/AsanaLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Asana1 from 'img/landing/asana-1.webp';
import Asana2 from 'img/landing/asana-2.webp';
import Asana3 from 'img/landing/asana-3.webp';

import AsanaLogo from 'img/canny-asana-integration.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

const AsanaLanding = () => {
  const trackEvent = useContext(TrackEventContext);

  useEffect(() => {
    trackEvent('Viewed Asana Integration Page');
  }, [trackEvent]);

  return (
    <div className="integrationsLanding">
      <AsanaLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <LazyLoadedImage alt="Asana logo" className="appLogo" loading="eager" src={AsanaLogo} />
            <div className="text">
              <h1 className="title">Canny for Asana</h1>
              <div className="subtitle">Sync feedback between Canny and&nbsp;Asana</div>
              <div className="links">
                <InstallExtensionButton
                  installButtonText="Install Asana"
                  installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fasana"
                />
                <a
                  href="http://help.canny.io/en/articles/7065590-asana-integration"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureImage">
              <LazyLoadedImage className="shadow" loading="eager" src={Asana1} />
            </div>
            <div className="featureText">
              <div className="title">Link Canny posts with Asana&nbsp;Tasks</div>
              <div className="subtitle">
                Push tasks from Canny to Asana and link between the&nbsp;two.
              </div>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureImage">
              <LazyLoadedImage className="shadow" src={Asana2} />
            </div>
            <div className="featureText">
              <div className="title">Push posts to&nbsp;Asana</div>
              <div className="subtitle">
                See a great idea in Canny? Push it over to Asana as a task and automatically link
                them&nbsp;together.
              </div>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureImage">
              <LazyLoadedImage className="shadow" src={Asana3} />
            </div>
            <div className="featureText">
              <div className="title">Keep statuses in&nbsp;sync</div>
              <div className="subtitle">
                No more worrying about losing track of status updates. Create rules to automatically
                sync statuses between Asana and&nbsp;Canny.
              </div>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default AsanaLanding;
